export default __webpack_public_path__ + "3ecf77b051d72d8fd5b6f652d9f41a71.svg";